<template>
  <el-aside class="main-layout-container" :width="isCollapse ? '0px' : '300px'">
    <el-row
      type="flex"
      class="row-bg"
      justify="center"
      align="middle"
      style="height: 100px"
    >
      <img
        src="../../assets/logoFixmin.png"
        style="width: 100%; height: 100%; vertical-align: top; object-fit: cover"
      />
    </el-row>

    <el-menu router :default-active="defaultActive" active-text-color="#2356c9">
      <el-menu-item class="dashed" index="/home">
        <i class="el-icon-s-home"></i>
        <span>Home</span>
      </el-menu-item>
      <el-submenu
        :index="idx.toString()"
        :key="idx"
        v-for="(item, idx) in items"
      >
        <template slot="title">
          <div v-if="item.title === 'Account Management'" @click="toggleBadge">
            <i :class="`el-icon-${item.icon}`"></i>
            <span slot="title">{{ item.title }} </span>
            <span v-if="showBadge && item.title === 'Account Management'" :class="{ 'badge': item.title === 'Account Management' }">{{ item.title === "Account Management" ? customersNewCount.length : null}}</span>
         </div>
         <div v-else>
          <i :class="`el-icon-${item.icon}`"></i>
            <span slot="title">{{ item.title }}</span>
            <span v-if="showBadge && item.title === 'Account Management'" :class="{ 'badge': item.title === 'Account Management' }">{{ item.title === "Account Management" ? customersNewCount.length : null}}</span>
         </div>
        </template>

        <el-menu-item
          v-for="(subItem, index) in item.items"
          :key="index"
          :index="subItem.link"
          >{{ subItem.title }}
          <span :class="{ 'badge': subItem.title === 'Customer New'  }">{{ subItem.title === "Customer New" ? customersNewCount.length : null}}</span>
          
          </el-menu-item
        >
      </el-submenu>

      <!--
      <el-menu-item class="dashed" index="/tax">
          <i class="el-icon-money"></i>
          <span>PPN Management (!)</span>
      </el-menu-item>
      -->

      <el-menu-item class="dashed" index="/banner">
        <i class="el-icon-s-home"></i>
        <span>Banner</span>
      </el-menu-item>
      <el-menu-item class="dashed" index="/order-display">
        <i class="el-icon-monitor"></i>
        <span>Order Display</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
  
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  props: ["drawer", 'isCollapse'],
  computed: {
    ...mapState({
      customersNewData: state => state.customerNew.customersNew.data,
    }),
    customersNewCount() {
      return this.customersNewData|| 0;
    },
  },
  methods: {
    ...mapActions({
      getCustomerNews: "customerNew/GetCustomerNews",
    }),
    fetchData() {
      this.getCustomerNews(); // Dispatch the action to fetch data
    },
    toggleBadge() {
      this.showBadge = !this.showBadge;
    },
    // ... your other methods
  },
  created() {
    
    this.fetchData(); // Call fetchData when the component is created
  },
  data() {
    const defaultActive = location.pathname.split("/");
    return {
      showBadge: true,
      defaultActive: `/${defaultActive[1]}`,
      items: [
        {
          active: true,
          action: "local_activity",
          title: "Account Management",
          icon: "user",
          items: [
            {
              title: "Customer Account",
              link: "/customer"
            },
            {
              title: "Staff Account",
              link: "/staff"
            },
            {
              title: "Customer New",
              link: "/customer-new"
            },
          ]
        },
        {
          action: "local_activity",
          title: "Product Management",
          icon: "goods",
          items: [
            {
              title: "Product",
              link: "/product"
            },
            {
              title: "Category",
              link: "/category"
            },
            {
              title: "Brand",
              link: "/brand"
            },
            {
              title: "Principal",
              link: "/principal"
            },
            {
              title: "Pushcart Product",
              link: "/pushcartproduct"
            }
          ]
        },
        {
          action: "local_activity",
          title: "Promo Management (!)",
          icon: "discount",
          items: [
            {
              title: "Promo & Voucher (!)",
              link: "/promovoucher"
            },
            {
              title: "Reward Point (!)",
              link: "/rewardpoint"
            },
            {
              title: "Form konversi point",
              link: "/conversionpoint"
            },
            {
              title: "Loyalty Item",
              link: "/loyaltyitem"
            },
            {
              title: "Loyalty Purchase",
              link: "/loyalty-purchase"
            }
          ]
        },
        {
          action: "local_activity",
          title: "Order Management",
          icon: "takeaway-box",
          items: [
            {
              title: "Order",
              link: "/order"
            },
            {
              title: "Retur",
              link: "/retur"
            }
          ]
        },
        {
          action: "local_activity",
          title: "App Management",
          icon: "mobile",
          items: [
            {
              title: "Terms Of Service (!)",
              link: "/termsofservice"
            },
            {
              title: "FAQ (!)",
              link: "/faq"
            },
            {
              title: "Contact Us (!)",
              link: "/contactus"
            }
          ]
        },
        {
          action: "local_activity",
          title: "System Management (!)",
          icon: "setting",
          items: [
            {
              title: "Branch (!)",
              link: "/branch"
            },
            {
              title: "PPN Management",
              link: "/tax"
            }
          ]
        },
        {
          action: "local_activity",
          title: "Audit Trail (!)",
          icon: "reading",
          items: [
            {
              title: "Login (!)",
              link: "/auditlogin"
            },
            {
              title: "Activity (!)",
              link: "/auditactivity"
            },
            {
              title: "System (!)",
              link: "/auditsystem"
            }
          ]
        },
        {
          action: "local_activity",
          title: "System",
          icon: "user",
          items: [
            {
              title: "Branch",
              link: "/branch"
            }
          ]
        },
        {
          action: "local_activity",
          title: "Report",
          icon: "goods",
          items: [
            {
              title: "Sales Report",
              link: "/reports"
            }
          ]
        },
        {
          action: "local_activity",
          title: "App Setting",
          icon: "goods",
          items: [
            {
              title: "Validation Shopping Cart",
              link: "/validation-shopping-cart"
            }
          ]
        },
      ]
    };
  },
};
</script>

<style>
.el-submenu {
  border-top: 1px solid #f0f0f0;
}
.el-menu-item {
  border-top: 1px solid #f0f0f0;
}

.badge{
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 3px 6px;
  font-size: 8px;
  font-weight: bold;
}

.hide{
  display: none;
}
.main-layout-container {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.3);
}

</style>
